import { render, staticRenderFns } from "./CatalogProductSingle.vue?vue&type=template&id=f5e5574a&scoped=true&"
import script from "./CatalogProductSingle.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSingle.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSingle.vue?vue&type=style&index=0&id=f5e5574a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e5574a",
  null
  
)

export default component.exports